import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import loadContent from "core-module/hoc/loadContent";
import * as api from "core-module/services/api";

import LoadingBox from "common/components/LoadingBox";

import SweetAlert from "react-bootstrap-sweetalert";

import PhoneByBillingpackage from "./PhoneByBillingpackage.jsx";
import BillingPackageSelectCard from "./BillingPackageSelectCard.jsx";
import NoPhoneAccount from "./NoPhoneAccount.jsx";

import EmergencyProfileWizard from "./911ProfileWizard.jsx";
import DnSelectWizard from "./911DnSelectWizard.jsx";

import { InvalidToken } from "core-module/services/error";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

class Phone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBillingPackage: 0,
      selectedEmergencyProfile: 0,
      voipBpsId: 0,
      associatedDnList: [],
      wizard: null,
      loading: false,
      alert: null
    };

    this.billingpackageList = this.props.getList((oGet, id) => id);
    this.emergencyprofileType = {};
    this.props.getList((oGet, id) => {
      this.emergencyprofileType[id] = oGet("emergencyprofile_type");
    });
  }

  //Wizard/Screen Rendering control

  handleSelectBillingPackage = event => {
    this.setState({ selectedBillingPackage: event.target.value });
  };

  closeWizard = () => this.setState({ wizard: null });

  selectDnWizard = (id, associatedDnList) => {
    this.setState({
      wizard: "dn",
      selectedEmergencyProfile: id,
      associatedDnList: associatedDnList
    });
  };

  selectEmergencyProfileWizard = id => {
    this.setState({
      wizard: "emergencyprofile",
      selectedEmergencyProfile: id
    });
  };

  //Data/API Events

  selectEmergencyProfile = async id => {
    const bpid = this.billingpackageList[this.state.selectedBillingPackage];
    this.setState({ loading: true });

    let endpoint = `user.${
      this.props.ids.user
    }/billingpackage.${bpid}/emergencyprofile_associate`;

    let payload = {
      emergencyprofileid: id
    };

    await api.postNload(
      endpoint,
      payload,
      0,
      `user.${
        this.props.ids.user
      }/billingpackage.${bpid}/emergencyprofile_summary`
    );

    this.setState({ loading: false });
  };

  onFinishEpWizard = async allStates => {
    const { classes } = this.props;
    let endpoint = `user.${this.props.ids.user}/billingpackage.${
      allStates.pathids.billingpackage
    }/emergencyprofile`;

    if (Number(allStates.pathids.emergencyprofile) !== 0) {
      endpoint = endpoint + "." + allStates.pathids.emergencyprofile;
    }
    const payload = allStates.address;
    let postRes = null;

    const shouldPost = () => {
      if (payload.city && payload.firstname
        && payload.lastname && payload.mode
        && payload.postalcode && payload.province) {
          return true
      }
      else {
        return false
      }
    };

    const getMessage = () => {
      return (
        <div>
          <p>Please provide:</p>
          <List>
            {!payload.city ? 
              <ListItem>
                <ListItemText primary="City"></ListItemText>
              </ListItem> 
            : null}
            {!payload.firstname ? 
              <ListItem>
                <ListItemText primary="First name"></ListItemText>
              </ListItem> 
            : null}
            {!payload.lastname ? 
              <ListItem>
                <ListItemText primary="Last name"></ListItemText>
              </ListItem> 
            : null}
            {!payload.mode ? 
              <ListItem>
                <ListItemText primary="Mode"></ListItemText>

              </ListItem> 
            : null}
            {!payload.postalcode ? 
              <ListItem>
                <ListItemText primary="Postal Code"></ListItemText>
              </ListItem> 
            : null}
            {!payload.province ? 
              <ListItem>
                <ListItemText primary="Province"></ListItemText>
              </ListItem> 
            : null}
            {!payload.streetname ? 
              <ListItem>
                <ListItemText primary="Street name"></ListItemText>
              </ListItem> 
            : null}
            {!payload.streetnumber ? 
              <ListItem>
                <ListItemText primary="Street number"></ListItemText>
              </ListItem> 
            : null}
          </List>
        </div>
      );
    }


    if (shouldPost()) {
      postRes = await api.post(endpoint, payload);
    } else {
      postRes = {
        error: "1",
        message: getMessage(),
        success: false
      }
    }

    if(postRes) {
      if (!("success" in postRes) || postRes.success === true) {
        try {
          await api.load(
            `user.${this.props.ids.user}/billingpackage.${
              allStates.pathids.billingpackage
            }/emergencyprofile_summary`
          );
        } catch (e) {
          if (e instanceof InvalidToken) {
            return false;
          } else {
            throw e;
          }
        }

        this.setState({
          errorMessage: "",
          wizard: null
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{
                display: "block",
                top: "5%",
                maxWidth: "90%",
                marginTop: "1%"
              }}
              title="Failed"
              onConfirm={() => this.setState({ alert: null })}
              confirmBtnCssClass={classes.button + " " + classes.success}
              confirmBtnText="DISMISS"
              showCancel={false}
            >
              {postRes.message}
            </SweetAlert>
          )
        });
      }
    }
  };

  onFinishDnWizard = async (bpid, dnbps) => {
    this.setState({ loading: true });

    let endpoint = `user.${
      this.props.ids.user
    }/billingpackage.${bpid}/emergencyprofile_associate`;

    try {
      for (let bps of dnbps) {
        let payload = {
          dnbillingpackageserviceid: bps,
          emergencyprofileid: this.state.selectedEmergencyProfile
        };
        await api.post(endpoint, payload);
      }

      await api.load(
        `user.${
          this.props.ids.user
        }/billingpackage.${bpid}/emergencyprofile_summary`
      );
    } catch (e) {
      if (e instanceof InvalidToken) {
        return false;
      } else {
        throw e;
      }
    }

    this.setState({ wizard: null, loading: false });
  };

  deleteEmergencyProfile = async id => {
    const handleConfirm = async () => {
      this.setState({ alert: null, loading: true });
      let endpoint = `user.${this.props.ids.user}/billingpackage.${
        this.billingpackageList[this.state.selectedBillingPackage]
      }/emergencyprofile.${id}`;

      const payload = { obsolete: true };

      try {
        await api.post(endpoint, payload);
        await api.load(
          `user.${this.props.ids.user}/billingpackage.${
            this.billingpackageList[this.state.selectedBillingPackage]
          }/emergencyprofile_summary`
        );
      } catch (e) {
        if (e instanceof InvalidToken) {
          return false;
        } else {
          throw e;
        }
      }

      this.setState({ loading: false });
    };

    this.setState({
      alert: (
        <SweetAlert
          info
          style={{
            display: "block",
            top: "5%",
            maxWidth: "90%",
            marginTop: "1%"
          }}
          title="Confirmation"
          onConfirm={handleConfirm}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.warning
          }
          confirmBtnText="Confirm"
          cancelBtnText="Cancel"
          showCancel
        >
          <h4>Do you want to delete this emergency profile?</h4>
        </SweetAlert>
      )
    });
  };

  render() {
    if (this.state.loading) {
      return <LoadingBox />;
    }

    if (
      this.billingpackageList == null ||
      this.billingpackageList.length === 0
    ) {
      return (
        <GridContainer justify="center">
          <GridItem key="noVoip" xs={12}>
            <NoPhoneAccount />
          </GridItem>
        </GridContainer>
      );
    }

    const bpid = this.billingpackageList[this.state.selectedBillingPackage];

    if (this.state.wizard === "emergencyprofile") {
      return (
        <div>
          {this.state.alert}
          <EmergencyProfileWizard
            onFinishWizard={this.onFinishEpWizard}
            closeWizard={this.closeWizard}
            pathids={{
              billingpackage: bpid,
              emergencyprofile: this.state.selectedEmergencyProfile
            }}
          />
        </div>
      );
    }

    if (this.state.wizard === "dn") {
      return (
        <DnSelectWizard
          onFinishDnWizard={this.onFinishDnWizard}
          closeWizard={this.closeWizard}
          pathids={{
            billingpackage: bpid,
            emergencyprofile: this.state.selectedEmergencyProfile
          }}
          associatedDnList={this.state.associatedDnList}
        />
      );
    }

    return (
      <div>
        {this.state.alert}
        <GridContainer justify="center">
          {this.billingpackageList.length === 1 ? null : (
            <GridItem key="selectbpid" xs={12}>
              <BillingPackageSelectCard
                selectedBillingPackage={this.state.selectedBillingPackage}
                handleSelect={this.handleSelectBillingPackage}
                billingpackageList={this.billingpackageList}
              />
            </GridItem>
          )}
          <GridItem xs={12}>
            <PhoneByBillingpackage
              pathids={{
                billingpackage: bpid
              }}
              emergencyProfileType={this.emergencyprofileType[bpid]}
              deleteEmergencyProfile={this.deleteEmergencyProfile}
              selectEmergencyProfile={this.selectEmergencyProfile}
              editEmergencyProfile={this.selectEmergencyProfileWizard}
              selectDnWizard={this.selectDnWizard}
              shouldRender="911Profile"
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(buttonStyle)(
  loadContent("user.session/billingpackage_voip", Phone)
);
